export default "__VITE_ASSET__AW35gMk3__"